export enum ExternalInformationType {
  RESIDENT_NUMBER = 'residentNumber',
  GENDER = 'residentGender',
  LAST_NAME = 'residentLastName',
  FIRST_NAME = 'residentFirstName',
  ROOM = 'room',
  HALLWAY_STATION = 'hallwayStation',
  LIVING_AREA = 'livingArea',
  SUPERVISOR_NAME = 'supervisorName',
  SUPERVISOR_STREET_ADDRESS = 'supervisorStreetAddress',
  SUPERVISOR_STREET_CITY = 'supervisorStreetCity',
  SUPERVISOR_EMAIL = 'supervisorEmail',
  DOCTOR_NAME = 'doctorName',
  DOCTOR_SUBJECT_AREA = 'doctorSubjectArea',
  NOTES = 'notes',
}
